import { ElementRef, inject, Injectable } from "@angular/core";
import { fromEvent } from "rxjs";
import { filter, map, share } from "rxjs/operators";

import { WindowRef } from "../tokens/window-ref";

@Injectable({
	providedIn: "root",
})
export class ScrollService {
	private window = inject<Window>(WindowRef);

	private scroll$ = fromEvent<UIEvent>(this.window, "scroll");

	pageByScroll$ = this.scroll$.pipe(
		map(() => this.window.document.scrollingElement),
		filter((el) => el.scrollTop + el.clientHeight > el.scrollHeight - 50),
		share(),
	);

	pageByScrollOnElement(element: ElementRef) {
		return fromEvent<UIEvent>(element.nativeElement, "scroll").pipe(
			map(() => element.nativeElement),
			filter((el) => el.scrollTop + el.clientHeight > el.scrollHeight - 50),
			share(),
		);
	}
}
